/** @format */

import { Box, Text } from "@chakra-ui/react";
import { usePersonalizacao } from "../../../context/usePersonalizacao";
import { useRecomendacao } from "../../../context/useRecomendacao";
import { validaValidadede } from "../../../utils";

export function ContentPrice({
  oferta = false,
  desconto = false,
  cashback = false,
  isHorizontal = false,
  props,
}) {
  const {
    valorde,
    valorpor,
    percentualdesconto,
    quantidadeparcelas,
    valorparcelas,
    validadede,
    validoapartir = validaValidadede({
      validadede: validadede,
    }),
    esgotado,
  } = props;
  const {cashbackLabel} = useRecomendacao();

  const {
    personalizacao: { card },
  } = usePersonalizacao();

  return (
    <Box paddingTop="0.25rem" paddingBottom="0.25rem">
      {oferta && (
        <>
          {!card.esconderPrecoOferta ? (
            <>
              <Box display="flex" flexDir="row" alignItems="center">
                <Text
                  color="#70747D"
                  fontSize="sm"
                  textDecorationLine="line-through"
                  display={isHorizontal && !valorde ? "none" : null}
                  visibility={valorde !== "" ? "visible" : "hidden"}>
                  {valorde !== ""
                    ? Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(valorde)
                    : "ﾠ"}
                </Text>
                {percentualdesconto !== "" && (
                  <Box
                    background={
                      validoapartir
                        ? "#70747D"
                        : card?.tabloide?.colorpreco
                        ? card?.tabloide?.colorpreco
                        : card.colorpreco
                    }
                    marginLeft={!valorde ? "0" : "0.5rem"}
                    paddingX="0.25rem"
                    borderRadius={2}>
                    <Text
                      display={
                        isHorizontal && !percentualdesconto ? "none" : null
                      }
                      color={
                        card?.tabloide?.colortextopercentual
                          ? card?.tabloide?.colortextopercentual
                          : card.colortextopercentual
                      }
                      fontSize="sm">
                      {"-" +
                        Intl.NumberFormat("pt-BR", {
                          style: "percent",
                          maximumFractionDigits: 2,
                        }).format(percentualdesconto / 100)}
                    </Text>
                  </Box>
                )}
              </Box>
            </>
          ) : null}
          <Text
            color={
              validoapartir
                ? "#70747D"
                : card?.tabloide?.colorpreco
                ? card?.tabloide?.colorpreco
                : card.colorpreco
            }
            fontSize="1.375rem"
            fontWeight="bold">
            {Intl.NumberFormat("pt-BR", {
              style: "currency",
              currency: "BRL",
            }).format(valorpor)}
          </Text>
          {quantidadeparcelas && quantidadeparcelas !== "0" && valorparcelas && valorparcelas !== "0" ? (
            <Text color="#70747D" fontSize="sm">
              {`${quantidadeparcelas}x de ${String(valorparcelas).replace(
                ".",
                ",",
              )}`}
            </Text>
          ) : (
            <Text></Text>
          )}
        </>
      )}
      {desconto && (
        <>
          <Box>
            <Box
              display="flex"
              flexDir={valorpor || valorde ? "row" : "column"}
              alignItems="baseline">
              <Text
                color={
                  validoapartir
                    ? "#70747D"
                    : card?.descontoexclusivo?.colorpreco
                    ? card?.descontoexclusivo?.colorpreco
                    : card.colorpreco
                }
                fontSize="1.375rem"
                fontWeight="bold">
                {Intl.NumberFormat("pt-BR", {
                  style: "percent",
                  maximumFractionDigits: 2,
                }).format(percentualdesconto / 100)}
              </Text>
              <Text
                fontSize="sm"
                color="#70747D"
                marginLeft={valorpor || valorde ? "0.25rem" : "0"}
                lineHeight="3">
                de desconto
              </Text>
            </Box>
            {valorde || valorpor ? (
              <Box
                display="flex"
                flexDir="row"
                alignItems="baseline"
                marginTop="0.25rem">
                {valorde && (
                  <Text
                    color="#70747D"
                    fontWeight="300"
                    fontSize="0.75rem"
                    textDecorationLine="line-through"
                    marginRight={"0.375rem"}
                    visibility={valorde ? "visible" : "hidden"}>
                    {valorde !== ""
                      ? Intl.NumberFormat("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }).format(valorde)
                      : "ﾠ"}
                  </Text>
                )}
                <Text
                  color="#555861"
                  fontSize="0.75rem"
                  fontWeight="bold"
                  visibility={valorpor ? "visible" : "hidden"}>
                  {valorpor !== ""
                    ? Intl.NumberFormat("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      }).format(valorpor)
                    : "ﾠ"}
                </Text>
              </Box>
            ) : null}
          </Box>
        </>
      )}

      {cashback && (
        <>
          <Box
            flexDir="row"
            alignItems="center"
            display={isHorizontal && !valorpor ? "none" : "flex"}>
            <Text
              color="#70747D"
              fontSize="sm"
              visibility={valorpor !== "" ? "visible" : "hidden"}>
              {valorpor
                ? "Por " +
                  Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }).format(valorpor)
                : "ﾠ"}
            </Text>
          </Box>
          <Text
            color={
              esgotado && !validoapartir
                ? "#70747D"
                : validoapartir
                ? "#70747D"
                : card?.cashback?.colorpreco
                ? card?.cashback?.colorpreco
                : card.colorpreco
            }
            textDecorationLine={
              esgotado && !validoapartir ? "line-through" : "none"
            }
            fontSize="1.375rem"
            fontWeight="bold">
            {"Ganhe " +
              Intl.NumberFormat("pt-BR", {
                style: "percent",
                maximumFractionDigits: 2,
              }).format(percentualdesconto / 100)}
          </Text>
          <Text lineHeight="3" fontSize="sm" color="#70747D">
            de {String(cashbackLabel).toLocaleLowerCase()}
          </Text>
        </>
      )}
    </Box>
  );
}
